import { UserSlugResolution } from '@chilipiper/api-client/src/firerouter'
import { MeetingCreatedTarget } from '@chilipiper/api-client/src/team-scheduling'
import { MeetingCreatedTarget as ConciergeMeetingCreatedTarget } from '@chilipiper/api-client/src/concierge-fire'
import { BookerInvitation } from '../../../types'

export type BookerSettings =
  | {
      id: string
      isOptional: boolean
      autoDecline: boolean
      type: 'Invited' | 'Host'
    }
  | {
      type: 'NotInvited'
    }

const isConciergeMeetingCreatedTarget = (
  meetingCreatedTarget: MeetingCreatedTarget | ConciergeMeetingCreatedTarget
): meetingCreatedTarget is ConciergeMeetingCreatedTarget => {
  return meetingCreatedTarget && 'required' in meetingCreatedTarget
}

/** @deprecated Use getBookerInvitationSettings instead */
export const getBookerSettings = (
  meetingCreatedTarget?: MeetingCreatedTarget | ConciergeMeetingCreatedTarget,
  bookerFromSmartParamenter?: UserSlugResolution,
  meetingAttemptBookerId?: string
): BookerSettings | undefined => {
  const bookerId = bookerFromSmartParamenter?.userId ?? meetingAttemptBookerId

  if (!meetingCreatedTarget || !bookerId || meetingCreatedTarget.type === 'BookerNotInvited') {
    return {
      type: 'NotInvited',
    }
  }

  return {
    id: bookerId,
    isOptional: isConciergeMeetingCreatedTarget(meetingCreatedTarget)
      ? !meetingCreatedTarget.required
      : meetingCreatedTarget.optional,
    autoDecline: meetingCreatedTarget.autoDeclineOnBookersBehalf,
    type: meetingCreatedTarget.type === 'BookerCalendarIfExist' ? 'Host' : 'Invited',
  }
}
type BookerInvite = {
  id: string
  isOptional: boolean
  autoDecline: boolean
  type: 'Invite'
}

type BookerNotInvited = {
  type: 'DoNotInvite'
}

export type BookerInvitationSettings = BookerInvite | BookerNotInvited

export const getBookerInvitationSettings = ({
  bookerInvitation,
  bookerFromSmartParameter,
  meetingAttemptBookerId,
}: {
  bookerInvitation?: BookerInvitation
  bookerFromSmartParameter?: UserSlugResolution
  meetingAttemptBookerId?: string
}): BookerInvitationSettings => {
  const bookerId = bookerFromSmartParameter?.userId ?? meetingAttemptBookerId

  if (bookerInvitation && bookerInvitation.type === 'Invite' && bookerId) {
    return {
      id: bookerId,
      isOptional: bookerInvitation.optional,
      autoDecline: bookerInvitation.autoDeclineOnBookersBehalf,
      type: 'Invite' as const,
    }
  }

  return {
    type: 'DoNotInvite' as const,
  }
}
